import { Injectable } from '@angular/core';
import { FormExtractorService } from 'src/app/modules/shared/services/form-extractor.service';
import { RadioCheckBoxEnum } from '../../../../common/radio.checkbox.enums';
import { CriterePondere } from '../../models/CriterePondere';
import { TypeCrJugement } from '../../models/TypeCrJugement';

@Injectable({
  providedIn: 'root'
})
export class CriteresService {

  constructor() {
  }

  getCriteres(controls: any, formExtractorService: FormExtractorService) {
    let criterePondere_iter = 0;

    const criterePondere_iters = formExtractorService.getIndexes(Array.from(controls.keys()), ['_SepSep_Initial_SepSep_', '_SepSep_CriterePondere'], 'TypeCrJugement_index_');


    const criteres = new TypeCrJugement();
    switch (controls.get('_SepSep_Initial_SepSep_TypeCrJugement_SepAtt_critereCDC')) {
      case RadioCheckBoxEnum.criterecdc:
        criteres.critereCDC = RadioCheckBoxEnum.emptyValue;
        criteres.critereLibre = null;
        criteres.criterePondere = null;
        criteres.criterePrix = null;
        criteres.typeCritere = RadioCheckBoxEnum.criterecdc;
        break;
      case RadioCheckBoxEnum.criterepondere:
        criteres.criterePondere = [];
        for (const criterePondere of Array.from(criterePondere_iters)) {
          criteres.criterePondere[criterePondere_iter] = new CriterePondere();
          criteres.criterePondere[criterePondere_iter].critere = this.sanitizeString(controls.get('_SepSep_Initial_SepSep_TypeCrJugement_index_' + (criterePondere_iter + 1) + '_SepSep_CriterePondere_SepAtt_critere'));
          criteres.criterePondere[criterePondere_iter].criterePCT = controls.get('_SepSep_Initial_SepSep_TypeCrJugement_index_' + (criterePondere_iter + 1) + '_SepSep_CriterePondere_SepAtt_criterePCT');
          criterePondere_iter++;
        }
        criteres.critereLibre = null;
        criteres.critereCDC = null;
        criteres.criterePrix = null;
        criteres.typeCritere = RadioCheckBoxEnum.criterepondere;
        break;
      case RadioCheckBoxEnum.criterelibre:
        criteres.critereLibre = controls.get('_SepSep_Initial_SepSep_TypeCrJugement_SepAtt_critereLibre');
        criteres.criterePondere = null;
        criteres.critereCDC = null;
        criteres.criterePrix = null;
        criteres.typeCritere = RadioCheckBoxEnum.criterelibre;
        break;
      case RadioCheckBoxEnum.critereprix:
        criteres.criterePrix = RadioCheckBoxEnum.emptyValue;
        criteres.criterePondere = null;
        criteres.critereCDC = null;
        criteres.critereLibre = null;
        criteres.typeCritere = RadioCheckBoxEnum.critereprix;
        break;
      case RadioCheckBoxEnum.emptyValue: 
      criteres.criterePrix = null;
      criteres.criterePondere = null;
      criteres.critereCDC = RadioCheckBoxEnum.emptyValue; 
      criteres.critereLibre = null;
      criteres.typeCritere = RadioCheckBoxEnum.emptyValue;
      break;
      default:
        criteres.criterePrix = null;
        criteres.criterePondere = null;
        criteres.critereCDC = null;
        criteres.critereLibre = null;
        criteres.typeCritere = null;
        break;
    }

    return criteres;
  }

  private sanitizeString(value: any): string | null {
    if (typeof value !== 'string') {
      return value;
    }
    const trimmed = value.trim();
    return trimmed.length > 0 ? trimmed : null;
  }
}
